$(document).ready(function () {
  var HomePage = {
    initJewelryInfo: function () {
      $(".jewelry-info-section .btn-show-info").on("click", function (e) {
        e.preventDefault();
        $(this).parent(".content").siblings(".jewelry-info").slideDown();
        $(".content .text").hide();
        $(this).addClass("hide");
        $(".jewelry-info-section .btn-hide-info").removeClass("hide");
      });
      $(".jewelry-info-section .btn-hide-info").on("click", function (e) {
        e.preventDefault();
        $(this).parent(".jewelry-info").slideUp();
        $(this).addClass("hide");
        $(".jewelry-info-section .btn-show-info").removeClass("hide");
        $(".content .text").show();
      });
    },
  };

  // New Homepage
  HomePage.initJewelryInfo();

  //  Magazine page script
  $(".magazine-nav-btn").on("click", function (e) {
    e.preventDefault();
    $(this).parent(".blog-nav").toggleClass("nav-open");
    $(this).siblings(".nav").slideToggle();
  });

  $(".latest-articles-slider").slick({
    arrows: false,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="24.073" viewBox="0 0 13 24.073"><path id="Right_arrow" data-name="Right arrow" d="M11.264,23a.744.744,0,0,0,.52-.211.7.7,0,0,0,0-1.016L1.615,11.839a.474.474,0,0,1,0-.678L11.784,1.227a.7.7,0,0,0,0-1.016.746.746,0,0,0-1.04,0L.575,10.145a1.883,1.883,0,0,0,0,2.71l10.169,9.934a.744.744,0,0,0,.52.211" transform="translate(0.5 0.573)" fill="#bc913f" stroke="#bc913f" stroke-width="1"/></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="24.073" viewBox="0 0 13 24.073"><path id="Right_arrow" data-name="Right arrow" d="M.736,23a.744.744,0,0,1-.52-.211.7.7,0,0,1,0-1.016l10.169-9.934a.474.474,0,0,0,0-.678L.216,1.227a.7.7,0,0,1,0-1.016.746.746,0,0,1,1.04,0l10.169,9.934a1.883,1.883,0,0,1,0,2.71L1.256,22.789A.744.744,0,0,1,.736,23" transform="translate(0.5 0.573)" fill="#bc913f" stroke="#bc913f" stroke-width="1"/></svg></button>',
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  if ($(window).width() < 1024) {
    $(".related-articles-slider").slick({
      arrows: false,
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  $(".article-products-slider").slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="24.073" viewBox="0 0 13 24.073"><path id="Right_arrow" data-name="Right arrow" d="M11.264,23a.744.744,0,0,0,.52-.211.7.7,0,0,0,0-1.016L1.615,11.839a.474.474,0,0,1,0-.678L11.784,1.227a.7.7,0,0,0,0-1.016.746.746,0,0,0-1.04,0L.575,10.145a1.883,1.883,0,0,0,0,2.71l10.169,9.934a.744.744,0,0,0,.52.211" transform="translate(0.5 0.573)" fill="#bc913f" stroke="#bc913f" stroke-width="1"/></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="24.073" viewBox="0 0 13 24.073"><path id="Right_arrow" data-name="Right arrow" d="M.736,23a.744.744,0,0,1-.52-.211.7.7,0,0,1,0-1.016l10.169-9.934a.474.474,0,0,0,0-.678L.216,1.227a.7.7,0,0,1,0-1.016.746.746,0,0,1,1.04,0l10.169,9.934a1.883,1.883,0,0,1,0,2.71L1.256,22.789A.744.744,0,0,1,.736,23" transform="translate(0.5 0.573)" fill="#bc913f" stroke="#bc913f" stroke-width="1"/></svg></button>',
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
